import React from 'react'
import { Helmet } from 'react-helmet-async'

const SeoHelmet = ({ title, keywords, description, canonicalLink, author }) => {
    return (
        <Helmet>
            <title>{title ? title : "Elite Partyz"}</title>
            {keywords && 
            <meta name="keywords" content={keywords} />}
            <meta name="description" content={description ? description : "Elite Partyz is revolutionising the party industry! The original and best double sided party platform. A game changer for party people and suppliers! "} />
            {author && 
            <meta name="author" content={author} />}
            {canonicalLink && 
            <link rel="canonical" href={canonicalLink} />}
            <meta property='og:url' content={canonicalLink ? canonicalLink : "/"} />
            <meta property="og:site_name" content={title ? title : "Elite Partyz App"} />
            <meta property="og:title" content={title ? title : "Elite Partyz - App | The Future App Of Party Planning"} />
            <meta property="og:description" content={description ? description : "Elite Partyz is revolutionising the party industry! The original and best double sided party platform. A game changer for party people and suppliers! "} />
            <meta property="og:type" content="website" />
            <meta property="og:image" content="/img/home.png" />
            <meta property="og:image:secure_url" content="/img/home.png" />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="777" />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:title" content="Elite Partyz - App | The Future App Of Party Planning" />
            <meta name="twitter:description" content="Elite Partyz is revolutionising the party industry! The original and best double sided party platform. A game changer for party people and suppliers!" />
            <meta name="twitter:image" content="/img/home.png" />
        </Helmet>
    )
}

export default SeoHelmet